import { Input, typographyRem } from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React from 'react'

import { isValidProps } from '../../../../pages/PageValidator'
import { ToolTip } from '../../../ToolTip'
import { GenericSectionStyle } from '../../GenericSectionStyle'
const { h4: H4, h5: H5 } = typographyRem

export interface CarMileageProps {
  updatedMileage: number | undefined
  handleUpdateMileage: (value: string) => void
  showErrorBanner: boolean
  validInputs: isValidProps
  notAnsweredMessage: string
  mileageError: string
}

export const CarMileage = ({
  updatedMileage,
  handleUpdateMileage,
  showErrorBanner,
  validInputs,
  notAnsweredMessage,
  mileageError,
}: CarMileageProps) => (
  <>
    <H4 id="mileage">Your car’s mileage.</H4>
    <GenericSectionStyle>
      <div className="generic-wrapper">
        <div className="question-container">
          <div className="question-text-container">
            <H5>How many miles do you think you’ll drive over the next 12 months?</H5>
          </div>
          <div className="input-info-container">
            <Input
              placeHolder="Estimated mileage"
              name="estimated-mileage"
              value={updatedMileage?.toString()}
              error={showErrorBanner && !validInputs?.mileage ? notAnsweredMessage : mileageError}
              onChange={(value: string) => handleUpdateMileage(value)}
              onBlur={() => {
                DataLayer.customEvent({
                  eventName: 'submit miles',
                  section: 'car',
                  eventType: 'form tracking',
                })
              }}
              valid={(typeof updatedMileage === 'number' && updatedMileage > 0) || false}
              className="input-input"
              type="number"
              dataCy="car-mileage-input-text-field"
              ariaLiveOnFocus
            />
            <ToolTip
              text="This is a pay-by-mile policy so we won't use this to set a price for your insurance, it's just so we can show you an estimate of how much you might pay for the year."
              className="tool-tip tip-top-small"
              dataCy="car-mileage-info-button"
            />
          </div>
        </div>
      </div>
    </GenericSectionStyle>
  </>
)
